import React, { useState } from 'react';
import { Plus, X, MapPin } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function SubRegionManager() {
  const {
    currentWorkspace,
    addSubRegion,
    removeSubRegion
  } = useWorkspace();
  const [newRegion, setNewRegion] = useState('');
  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();
    if (newRegion.trim()) {
      addSubRegion(newRegion.trim());
      setNewRegion('');
    }
  };
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6 space-y-6" data-id="element-376">
      <div data-id="element-377">
        <h3 className="text-lg font-medium text-gray-900" data-id="element-378">
          Sub-Regions Management
        </h3>
        <p className="mt-1 text-sm text-gray-500" data-id="element-379">
          Define specific geographic or logical sub-regions for the{' '}
          {currentWorkspace.name}. These can be used to segment data and target
          specific audiences.
        </p>
      </div>

      <form onSubmit={handleAdd} className="flex flex-col sm:flex-row gap-3" data-id="element-380">
        <div className="relative flex-1 min-w-0" data-id="element-381">
          <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-382" />
          <input type="text" value={newRegion} onChange={e => setNewRegion(e.target.value)} placeholder="Enter sub-region name (e.g., 'Sao Paulo', 'North', 'Retail Team')" className="block w-full rounded-md border-gray-300 pl-10 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-383" />
        </div>
        <button type="submit" disabled={!newRegion.trim()} className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap flex-shrink-0" data-id="element-384">
          <Plus className="h-4 w-4 flex-shrink-0" data-id="element-385" />
          <span data-id="element-386">Add Region</span>
        </button>
      </form>

      <div className="space-y-3" data-id="element-387">
        <h4 className="text-sm font-medium text-gray-700" data-id="element-388">
          Active Sub-Regions
        </h4>
        {currentWorkspace.subRegions.length === 0 ? <div className="text-sm text-gray-500 italic bg-gray-50 p-4 rounded-md text-center" data-id="element-389">
            No sub-regions defined yet. Add one above.
          </div> : <div className="flex flex-wrap gap-2" data-id="element-390">
            {currentWorkspace.subRegions.map(region => <span key={region} className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-blue-50 text-blue-700 border border-blue-100" data-id="element-391">
                <span className="truncate max-w-[150px]" data-id="element-392">{region}</span>
                <button onClick={() => removeSubRegion(region)} className="text-blue-400 hover:text-blue-600 focus:outline-none flex-shrink-0" title="Remove region" data-id="element-393">
                  <X className="h-3 w-3" data-id="element-394" />
                </button>
              </span>)}
          </div>}
      </div>
    </div>;
}